import axios from 'axios';
import { useDispatch } from 'react-redux';
import {
  NOTIFICATION_LEVEL_ERROR, NOTIFICATION_LEVEL_SUCCESS,
} from '@avtechsoftware/ra-javascript-utilities/src/types/NotificationLevels';
import { useState } from 'react';
import { pushSessionMessage } from '../../redux/slices/toastNotificationSlice/toastNotificationSlice';
import envConfig from '../../envConfig';
import {
  refreshFilteredDeviceList,
} from '../../redux/slices/filteredDeviceListSlice/filteredDeviceListSlice';

const useArchiveDevice = () => {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const archiveDevice = (deviceId) => {
    setSubmitting(true);
    const formData = new FormData();
    formData.append('deviceId', deviceId);
    axios.post(`${envConfig.raaUrl}/devices/data/immediate-transfer-to-inventory`, formData)
      .then(() => {
        dispatch(pushSessionMessage({
          level: NOTIFICATION_LEVEL_SUCCESS,
          title: 'Success',
          body: 'Device Archived.',
        }));
        dispatch(refreshFilteredDeviceList());
      })
      .catch(() => {
        dispatch(pushSessionMessage({
          level: NOTIFICATION_LEVEL_ERROR,
          title: 'Unexpected error',
          body: 'Unexpected error archiving device.',
        }));
      }).finally(() => {
        setSubmitting(false);
        setSubmitted(true);
      });
  };

  const archiveDevices = (deviceIds, onComplete) => {
    const counts = {
      success: 0,
      error: 0,
    };
    setSubmitting(true);
    const requests = deviceIds.map((deviceId) => {
      const formData = new FormData();
      formData.append('deviceId', deviceId);
      return axios.post(`${envConfig.raaUrl}/devices/data/immediate-transfer-to-inventory`, formData)
        .then(() => {
          counts.success += 1;
        })
        .catch(() => {
          counts.error += 1;
        });
    });
    Promise.allSettled(requests).finally(() => {
      if (counts.success > 0) {
        dispatch(pushSessionMessage({
          level: NOTIFICATION_LEVEL_SUCCESS,
          title: 'Success',
          body: `${counts.success} Devices Archived.`,
          duration: 10000,
        }));
        dispatch(refreshFilteredDeviceList());
      }

      if (counts.error > 0) {
        dispatch(pushSessionMessage({
          level: NOTIFICATION_LEVEL_ERROR,
          title: 'Errors occurred',
          body: `${counts.error} Devices had an unexpected error while archiving.`,
          duration: 10000,
        }));
      }

      setSubmitting(false);
      setSubmitted(true);
      onComplete();
    });
  };

  return {
    archiveDevice,
    submitting,
    submitted,
    archiveDevices,
  };
};

export default useArchiveDevice;
